import React, { memo } from 'react';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SpinnerCircles from './Spinner/SpinerCircles';
import './ConfirmationModal.css';

const ConfirmationModal = memo(
  ({
    isOpen,
    onCancel,
    onConfirm,
    bodyText,
    confirmBtnText,
    closeBtnText,
    ignoreConfirmButton,
    customBodyComponent,
    warning,
    resetBoxComponent,
    disableConfirmBtn,
    headerText,
    close,
    subHeader,
    loading,
    className,
    modalClassName,
    size,
    extraContent,
  }) => {
    return (
      <Modal
        isOpen={isOpen}
        id="warning-modal"
        className={className}
        modalClassName={modalClassName}
        size={size}
      >
        <ModalHeader className={warning && 'modal-container'}>
          {ignoreConfirmButton || warning ? 'Warning' : headerText ? headerText : "Are you sure?"}
        </ModalHeader>
        <ModalBody>
          <div className="container">
            {resetBoxComponent ? (
              customBodyComponent
            ) : (
              <Row>
                <>
                  <Col lg={2} md={2} sm={6}>
                    <div className="delete-box-icon">
                      <FontAwesomeIcon
                        style={{ width: '40px', height: '40px' }}
                        icon="exclamation-triangle"
                        color="#3b5aa9"
                      />
                    </div>
                  </Col>
                  <Col lg={10} md={10} sm={6}>
                    <h6>{subHeader}</h6>
                    <p>{bodyText}</p>
                    {extraContent}
                  </Col>
                </>
              </Row>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            outline
            id={close ? 'warning-close' : 'warning-cancel'}
            onClick={onCancel}
            disabled={loading}
            style={ignoreConfirmButton ? { marginLeft: 'auto' } : null}
            className="btn-strong"
          >
            {close ? `Close` : closeBtnText ? closeBtnText : `Cancel`}
          </Button>
          {!ignoreConfirmButton && (
            <Button
              color="primary"
              onClick={onConfirm}
              disabled={disableConfirmBtn || loading}
              className="btn-assign-edge"
            >
              {loading ? <SpinnerCircles /> : (confirmBtnText || 'Proceed')}
            </Button>
          )}
        </ModalFooter>
      </Modal>
    );
  },
);

export default ConfirmationModal;
